export default __webpack_public_path__ + "static/media/AXSOL_COWORKING-MENTIONS_LEGALES.7302325b.pdf";